import { processMessages } from '@/api/messages'

const errorPipeline = (jsConn) => {
  return processMessages(jsConn)
}

export { errorPipeline }
